import {Typography, useTheme} from "@mui/material";
import {ResourceWrapper} from "../../../../eventer-pod/client/ResourceWrapper.ts";

interface EventTitleProps {
    readonly event: ResourceWrapper
}

export default function EventTitle(props: EventTitleProps) {
    const theme = useTheme()
    
    const title = props.event.getFirstString('https://schema.org/name') ?? '(ohne Titel)'

    return (
        <Typography 
            variant="h6"
            component="h2"
            sx={{ 
                fontWeight: 600,
                lineHeight: 1.3,
                color: theme.palette.text.primary
            }}
        >
            {title}
        </Typography>
    )
}
